package one.healthium.update_food_preferences.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class FoodPreferenceItemDto(
    @SerialName("key") val id: String,
    @SerialName("text") val text: String,
    @SerialName("status") val status: String,
)
